import MaoDeObraView from "../../components/gestaoOrcamentaria/MaoDeObraView";
import { getRoleFromToken } from "../../api";
import { DEPARTAMENTOS_DESPESAS_MAO_DE_OBRA, departamentosVisiveis } from "../../constants/departamentosOrcamento";

export default function DespesasMaoDeObra() {
  const departamentos = departamentosVisiveis(getRoleFromToken()).filter((d) => DEPARTAMENTOS_DESPESAS_MAO_DE_OBRA.includes(d));
  return <MaoDeObraView tituloModulo="Despesas Mão de Obra" departamentos={departamentos} />;
}
